import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

export type SortOption = 'nombre_asc' | 'nombre_desc' | 'cv_desc' | 'cv_asc';

export interface SortParams {
  sortBy?: string;
  sortOrder?: string;
}

interface SortOptionItem {
  value: SortOption;
  label: string;
  sortBy?: string;
  sortOrder?: string;
}

@Component({
  selector: 'app-table-filter',
  standalone: true,
  imports: [CommonModule, MatRadioModule, FormsModule],
  templateUrl: './table-filter.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    :host {
      --mat-sys-primary: #000;
    }
  `],
})
export class TableFilterComponent {
  sortChange = output<SortParams>();

  isOpen = signal(false);
  selectedOption = signal<SortOption>('nombre_asc');

  readonly options: SortOptionItem[] = 
    [{ value: 'cv_desc', label: 'Última actualización (más recientes)', sortBy: 'cv_ultima_actualizacion_en', sortOrder: 'desc' },
    { value: 'cv_asc', label: 'Última actualización (más antiguos)', sortBy: 'cv_ultima_actualizacion_en', sortOrder: 'asc' },
    { value: 'nombre_asc', label: 'Nombre A-Z' },
    { value: 'nombre_desc', label: 'Nombre Z-A', sortBy: 'nombre', sortOrder: 'desc' }
  ];

  toggle(): void {
    this.isOpen.update((v) => !v);
  }

  onSelect(option: SortOptionItem): void {
    this.selectedOption.set(option.value);
    this.sortChange.emit({ sortBy: option.sortBy, sortOrder: option.sortOrder });
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('app-table-filter')) {
      this.isOpen.set(false);
    }
  }
}
